var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLegal = function SvgLegal(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 1H1V11H3",
    stroke: "#191919",
    strokeWidth: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11L12 11L12 1L10 1",
    stroke: "#191919",
    strokeWidth: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.17898 9.76136V4.21591H6.94176V9.76136H6.17898ZM6.56676 3.09091C6.41051 3.09091 6.27699 3.03835 6.16619 2.93324C6.0554 2.82528 6 2.69602 6 2.54545C6 2.39489 6.0554 2.26705 6.16619 2.16193C6.27699 2.05398 6.41051 2 6.56676 2C6.72301 2 6.85653 2.05398 6.96733 2.16193C7.07812 2.26705 7.13352 2.39489 7.13352 2.54545C7.13352 2.69602 7.07812 2.82528 6.96733 2.93324C6.85653 3.03835 6.72301 3.09091 6.56676 3.09091Z",
    fill: "black"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLegal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/legal.92941ca8a6daa935086e14dc78a78b93.svg";